import { render, staticRenderFns } from "./qx-table.vue?vue&type=template&id=4952029a&scoped=true"
import script from "./qx-table.vue?vue&type=script&lang=js"
export * from "./qx-table.vue?vue&type=script&lang=js"
import style0 from "./qx-table.vue?vue&type=style&index=0&id=4952029a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4952029a",
  null
  
)

export default component.exports